import { PlusOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import FormInput from "components/FormInput";
import { INPUT_TYPE } from "config/constants";
import { OPTION_VAT_PERCENT, PRODUCT_INPUT_TYPE, isPresetVatPercent } from "pages/App/Product/ProductGroup/conts";
import { useState } from "react";
import { getFile } from "utils/helperFuncs";
import styles from "./index.module.scss";

const VatPercentTypeInput = ({ form, rowIndex, inputOptionsVat }) => {
  const currentVatPercent = form?.getFieldValue(["products", rowIndex, "vatPercent"]);
  const initialTaxablePercentVAT = isPresetVatPercent(currentVatPercent) ? currentVatPercent : "OTHER";
  const [taxablePercentVAT, setTaxablePercentVAT] = useState(initialTaxablePercentVAT);

  const handleChangeTaxablePercentVAT = (value) => {
    setTaxablePercentVAT(value);
    if (value !== "OTHER") {
      const products = form?.getFieldValue("products") || [];
      const nextProducts = [...products];
      nextProducts[rowIndex] = { ...nextProducts[rowIndex], vatPercent: value };
      form?.setFieldsValue({ products: nextProducts });
    }
  };

  return (
    <Row gutter={8} wrap={false}>
      <Col flex="auto">
        <FormInput
          type={INPUT_TYPE.SELECT}
          formItemOptions={{
            name: [rowIndex, "taxablePercentVAT"],
            initialValue: initialTaxablePercentVAT,
          }}
          inputOptions={{ options: OPTION_VAT_PERCENT, onChange: handleChangeTaxablePercentVAT }}
        />
      </Col>
      <Col flex="80px">
        <FormInput
          type={INPUT_TYPE.NUMBER}
          formItemOptions={{ name: [rowIndex, "vatPercent"] }}
          inputOptions={{ ...inputOptionsVat, disabled: taxablePercentVAT !== "OTHER" }}
        />
      </Col>
    </Row>
  );
};

const EditableCell = ({
  editing,
  dataIndex,
  inputType,
  nameInput,
  options,
  rowIndex,
  children,
  initialValue,
  isDisableUpload,
  attributeLabel,
  form,
  ...restProps
}) => {
  const uploadButton = (
    <div className={styles.uploadButton}>
      <PlusOutlined />
    </div>
  );

  const inputOptionsPrices = {
    min: 0,
    maxLength: 11,
  };

  const inputOptionsVat = {
    min: 0,
    max: 100,
    maxLength: 4,
  };

  const inputNode = () => {
    switch (inputType) {
      case PRODUCT_INPUT_TYPE.UPLOAD_IMAGE:
        return (
          <FormInput
            type={INPUT_TYPE.IMAGE_UPLOAD}
            formItemOptions={{
              getValueFromEvent: getFile,
              name: [rowIndex, ...nameInput],
              valuePropName: "fileList",
              rules: [{ required: true, message: "Vui lòng tải lên ảnh sản phẩm" }],
            }}
            inputOptions={{
              showUploadList: {
                showPreviewIcon: false,
              },
              className: "upload-image",
            }}
            inputChildren={isDisableUpload ? null : uploadButton}
          />
        );

      case PRODUCT_INPUT_TYPE.INPUT_PRODUCT_CODE:
        return (
          <FormInput
            formItemOptions={{
              name: [rowIndex, ...nameInput],
              rules: [{ required: true, message: "Vui lòng nhập mã sản phẩm" }],
            }}
          />
        );

      case PRODUCT_INPUT_TYPE.INPUT_SHORT_CODE:
        return (
          <FormInput
            formItemOptions={{
              name: [rowIndex, ...nameInput],
              rules: [{ required: true, message: "Vui lòng nhập tên sản phẩm" }],
            }}
          />
        );

      case PRODUCT_INPUT_TYPE.INPUT_CURRENCY:
        return (
          <FormInput
            type={INPUT_TYPE.CURRENCY_INPUT}
            formItemOptions={{
              name: [rowIndex, ...nameInput],
              rules: [{ required: true, message: "Vui lòng nhập giá có VAT" }],
            }}
            inputOptions={{ ...inputOptionsPrices }}
          />
        );

      case PRODUCT_INPUT_TYPE.INPUT_VAT:
        return (
          <FormInput
            type={INPUT_TYPE.NUMBER}
            formItemOptions={{ name: [rowIndex, ...nameInput] }}
            inputOptions={{ ...inputOptionsVat }}
          />
        );

      case PRODUCT_INPUT_TYPE.SELECT:
        return (
          <FormInput
            type={INPUT_TYPE.SELECT}
            formItemOptions={{
              name: [rowIndex, ...nameInput],
              initialValue: initialValue,
              rules: [{ required: true, message: `Vui lòng chọn ${attributeLabel}` }],
            }}
            inputOptions={{ options: options }}
          />
        );

      case PRODUCT_INPUT_TYPE.VAT_PERCENT_TYPE:
        return <VatPercentTypeInput form={form} rowIndex={rowIndex} inputOptionsVat={inputOptionsVat} />;

      default:
        return;
    }
  };
  return (
    <td {...restProps}>
      <div>{editing ? inputNode() : children}</div>
    </td>
  );
};

export default EditableCell;
